import React__default from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var Check = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React__default.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "45",
    height: "48",
    viewBox: "0 0 45 48"
  }, props), React__default.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React__default.createElement("path", {
    d: "M-5 2h48v48H-5z"
  }), React__default.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2"
  }, React__default.createElement("path", {
    d: "M11 25h16v10H11zm4 0v-6a4.012 4.012 0 0 1 4-4 4.012 4.012 0 0 1 4 4v6"
  }), React__default.createElement("path", {
    d: "M37 29c0 9.941-8.059 18-18 18S1 38.941 1 29V9l18-4 18 4v20z"
  })), React__default.createElement("path", {
    d: "M27 2h16v16H27z"
  }), React__default.createElement("g", {
    transform: "translate(25)"
  }, React__default.createElement("circle", {
    cx: "10",
    cy: "10",
    r: "10",
    fill: "#FFF"
  }), React__default.createElement("path", {
    fill: "#009F45",
    fillRule: "nonzero",
    d: "M10 2c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM9 13.4L5.6 10 7 8.6l2 2 4-4L14.4 8 9 13.4z"
  }))));
});

export default Check;
//# sourceMappingURL=check.svg.js.map
